"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const getContrast_1 = __importDefault(require("./getContrast"));
const isContrastWithinW3CRange = (lighterColor, darkerColor) => {
    let contrast;
    try {
        contrast = getContrast_1.default(lighterColor, darkerColor);
    }
    catch (e) {
        console.error(e);
        return {
            aa: {
                base: false,
                largeText: false,
            },
            aaa: {
                base: false,
                largeText: false,
            },
            nonText: {
                base: false,
            },
        };
    }
    return {
        // https://www.w3.org/TR/WCAG21/#contrast-minimum
        aa: {
            base: contrast >= 4.5,
            largeText: contrast >= 3,
        },
        // https://www.w3.org/TR/WCAG21/#contrast-enhanced
        aaa: {
            base: contrast >= 7,
            largeText: contrast >= 4.5,
        },
        nonText: {
            base: contrast >= 3,
        },
    };
};
exports.default = isContrastWithinW3CRange;
